<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    Estatuto SBCCV
  </app-header-dialog>

  <div *ngIf="entityForm">

    <div class="content">

      <mat-form-field style='width: 80px;' appearance="outline">
        <mat-label>Posição</mat-label>
        <input matInput type="number" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.position"
          autocomplete="off">
      </mat-form-field>

      <mat-form-field style='width: 180px; margin-left: 20px;' appearance="outline">
        <mat-label>Data</mat-label>
        <input matInput [matDatepicker]="picker" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field style='width: 620px; margin-left: 20px;' appearance="outline">
        <mat-label>Título</mat-label>
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.title"
          autocomplete="off">
      </mat-form-field>

      <mat-tab-group>
        <mat-tab>
          <ng-template mat-tab-label>
            <div>Texto</div>
          </ng-template>

          <div style="text-align: justify;">
            <ckeditor [config]="{ 
                    toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
              [formControl]="entityForm.controls.text" [editor]="Editor"></ckeditor>
            <mat-error *ngIf="entityForm.controls.text.hasError('required')">
              O Texto é obrigatório
            </mat-error>
          </div>

        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <div>HTML</div>
          </ng-template>

          <textarea class='text-area' autocomplete="off" [(ngModel)]="htmlContent"
            [ngModelOptions]="{ standalone: true }"
            (input)="entityForm.controls.text.setValue(htmlContent, { emitEvent: false })">
          </textarea>

        </mat-tab>

      </mat-tab-group>

    </div>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
      <button *ngIf="!isEdit" matTooltip='Inserir' mat-raised-button
        (click)="matDialogRef.close(['insert', entityForm])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>
      <button *ngIf="isEdit" matTooltip='Alterar' mat-raised-button (click)="matDialogRef.close(['update', entityForm])"
        [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

    </div>

  </div>

</div>